export default "__VITE_ASSET__ab37a4fc__"